import posthog from "posthog-js";

export const track = (
  eventName: string,
  props: Record<string, unknown> = {},
) => {
  try {
    posthog.capture(eventName, props);
  } catch {
    // Silently ignore tracking errors
  }
};

export const captureException = (
  error: unknown,
  context?: Record<string, unknown>,
) => {
  try {
    const normalizedError =
      error instanceof Error ? error : new Error(String(error));
    const enrichedContext =
      error instanceof Error ? context : { ...context, thrown: error };
    posthog.captureException(normalizedError, enrichedContext);
  } catch {
    // Silently ignore tracking errors
  }
};
